import { Fragment, memo, useCallback, useEffect, useState } from 'react';

import Typography from '@mui/material/Typography';
import Grid from '@mui/material/GridLegacy';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import {
    useGridApiContext,
} from '@mui/x-data-grid-pro';
import { useDispatch, useSelector } from 'react-redux';
import dashboardActions from '../../../Redux/Dashboard/actions';

import ListAddresses from "./ListAddresses";
import ProductTable from './ProductTable';
import Surcharges from './Surcharges';
import Totals from './Totals';
import { capitalizeEveryWord, capitalizeFirstLetter, count, handleFetch, isDefined, replaceStringWith } from '../../../config/helpers';
import dayjs from 'dayjs';
import Link from 'next/link';
import actions from '../../../Redux/Agent/actions';
import { useRouter } from 'next/router';
import { convertToDoris } from '../../../config/requests';
import { topMiddleErrorAlert } from '../../../Redux/Alert/apiSaga';
import useAlert from '../../../_hooks/useAlert';
import useSafePush from '../../../_hooks/useSafePush';
import dynamic from 'next/dynamic';

const Spinner = dynamic(() => import('../../Spinners/Spinner'));

const RecordContainer = ({ customer_id, row }) => {
    const dispatch = useDispatch();
    const { defaultAccount } = useSelector(state => state.authReducer);
    const { dashboardLoaders } = useSelector(state => state.dashboardReducer);
    const dashboardReducer = useSelector(state => state.dashboardReducer);
    const agentReducer = useSelector(state => state.agentReducer);

    const apiRef = useGridApiContext();
    const [viewType, setViewType] = useState('');
    const [typeIndex, setTypeIndex] = useState(false);
    const [info, setInfo] = useState(null);

    const router = useRouter();
    const { topMiddleAlert } = useAlert();
    const { safePush } = useSafePush();

    const [width, setWidth] = useState(() => {
        const dimensions = apiRef.current.getRootDimensions();
        return dimensions.viewportInnerSize.width;
    });



    const handleViewportInnerSizeChange = useCallback(() => {
        const dimensions = apiRef.current.getRootDimensions();
        setWidth(dimensions.viewportInnerSize.width);
    }, [apiRef]);

    useEffect(() => {
        return apiRef.current.subscribeEvent(
            'viewportInnerSizeChange',
            handleViewportInnerSizeChange,
        );
    }, [apiRef, handleViewportInnerSizeChange]);

    useEffect(() => {
        let idToQuery = defaultAccount.CustomerID;

        console.log('QUERY', customer_id)

        //if an agent has selected a customer id from the search, set the id to query THAT customer ID
        if (customer_id != false) {
            idToQuery = customer_id;
        } else {
            if (agentReducer && agentReducer.actingAsCustomerID) idToQuery = agentReducer.actingAsCustomerID
        }

        //if an agent has selected a customer id from the search, set the id to query THAT customer ID
        // if(agentReducer && agentReducer.actingAsCustomerID) idToQuery = agentReducer.actingAsCustomerID

        let TYPE = null;
        let id = null;
        let quote_type = null;

        if (row.OrderID) {
            TYPE = 'ORDER';
            id = row.OrderID;
        }
        else if (row.QuoteID) {
            TYPE = 'QUOTE';
            id = row.QuoteID;
            quote_type = row.quote_type;
        }

        const toLower = TYPE.toLowerCase();
        const firstLetter = capitalizeFirstLetter(toLower);

        setViewType({
            uppercase: TYPE,
            lowercaseType: toLower,
            firstLetter: firstLetter
        })


        setTypeIndex(toLower);

        dispatch({
            type: dashboardActions[`DASHBOARD_GET_${TYPE}_BY_ID`],
            payload: {
                customer_id: idToQuery,
                id: id,
                quote_type: quote_type
            }
        })

        return () => {
            dispatch({ type: dashboardActions[`DASHBOARD_RESET_ACTIVE_${TYPE}_STATE`] })
        }
    }, [])

    useEffect(() => {
        stateInfoBuilder(typeIndex);

    }, [dashboardReducer.dashboardData.quote, dashboardReducer.dashboardData.order])

    const stateInfoBuilder = (type) => {
        let stateObj = {};
        if (!type || type == null || count(dashboardReducer.dashboardData[typeIndex]) == 0) return;

        const rowData = dashboardReducer.dashboardData[typeIndex].data;
        if (type == 'quote') {
            stateObj = {
                headings: {
                    customer_ID: rowData.details.CustomerID,
                    quote_ref: rowData.details.QuoteID,
                    last_modified: rowData.details.InvoiceDate,
                },
                ID: rowData.details.QuoteID,
                type: 'quote'
            }

        }
        else if (type == 'order') {
            stateObj = {
                headings: {
                    customer_ID: rowData.details.CustomerID,
                    invoice_ref: rowData.details.OrderID,
                    invoice_date: rowData.details.OrderDate,
                    tax_date: dayjs(rowData.details.VATDate).format('DD/MM/YYYY'),
                    PO_reference: rowData.details.POReference
                },
                ID: rowData.details.OrderID,
                type: 'order'
            }

        }

        setInfo(stateObj);
    }



    const checkQuoteType = async () => {
        console.log(row.quote_type);
        // dispatch({
        //     type: "SET_PAGE_SPINNER",
        //     payload: true
        // });


        if (viewType?.firstLetter == 'Order') {
            console.log(info)
            safePush(`${process.env.NEXT_PUBLIC_USER_HOME_ROUTE}/${info.type}s/${info.ID}`);
        }
        else {
            if (row.quote_type == 1) {
                // console.log("herbert")

                let idToQuery = isDefined(defaultAccount) ? defaultAccount.CustomerID : null;
                if (agentReducer && agentReducer.actingAsCustomerID) idToQuery = agentReducer.actingAsCustomerID

                const payload = {
                    customer_id: idToQuery,
                    quote_id: row.QuoteID
                }

                const conversion = await handleFetch(convertToDoris(payload));


                if (conversion.status == 'success') {
                    safePush(`${process.env.NEXT_PUBLIC_USER_HOME_ROUTE}/${info.type}/${conversion.quote_id}`);
                }
                else {
                    topMiddleAlert('ERROR', 'Oops, something went wrong!');
                }

                // dispatch({
                //     type: dashboardActions.SET_CONVERT_QUOTE_STATE,
                //     payload: {
                //         quote_id: row.QuoteID,
                //         state: true,
                //     }
                // })
            }
            else if (row.quote_type == 0) {
                // console.log("doris")
                safePush(`${process.env.NEXT_PUBLIC_USER_HOME_ROUTE}/${info.type}/${info.ID}`);
            }

        }

    }


    return (
        (info == null) || (dashboardLoaders && dashboardLoaders[`get${viewType.firstLetter}`]) ? <Spinner sx={{
            position: 'relative',
            top: '25%',
            left: '50%',
            // height: '250px'
        }} /> : (
            dashboardReducer.dashboardData[typeIndex] && dashboardReducer.dashboardData[typeIndex].status == 'success' ? <Stack
                sx={{
                    px: 2,
                    height: '100%',
                    position: 'sticky',
                    left: 0,
                    backgroundColor: 'rgb(247 247 247)',
                    height: 'fit-content'
                }}
                direction="column"
            >
                <Paper sx={{ backgroundColor: 'rgb(247 247 247)', border: 'none', boxShadow: 'none', flex: 1, mx: 'auto', width: '95%' }}>
                    <Stack direction="column" spacing={1} sx={{ height: 1 }}>
                        <Box justifyContent="space-between" className="d-flex mt-4">
                            <h2 style={{ fontSize: 16 }} className="mt-4 uppercase" component="h6" variant="h3">{`VIEWING ${info.type} #${info.ID}`} </h2>
                            {/* <Link onClick={checkQuoteType} className="d-flex" style={{alignItems: 'center'}} href={`/myaccount/${info.type}?quote_id=${info.ID}`}> */}
                            {viewType && <Button sx={{ height: '25%' }} size="small" onClick={checkQuoteType} variant="contained">
                                {
                                    viewType?.firstLetter == 'Quote' ? 'Edit Quote' : 'View Order'
                                }
                            </Button>}
                            {/* </Link> */}
                        </Box>
                        <Divider className="mb-3" />
                        {info && info.headings && Object.keys(info.headings).map((key, idx) => (
                            info.headings[key] != "" && <Fragment key={idx}>
                                <Grid container>
                                    <Grid xs={2} item>
                                        <Typography className="fw-bold" variant="h6">
                                            {`${capitalizeEveryWord(replaceStringWith(key, '_', ' '))}:`}
                                        </Typography>
                                    </Grid>
                                    <Grid xs={2} item>
                                        <Typography className="fw-bold" variant="h6">
                                            {info.headings[key]}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Fragment>
                        ))}
                        {dashboardReducer.dashboardData[typeIndex] && dashboardReducer.dashboardData[typeIndex].data.credit_notes && count(dashboardReducer.dashboardData[typeIndex].data.credit_notes) > 0 && (
                            <Grid container>
                                <Grid xs={2} item>
                                    <Typography className="fw-bold" variant="h6">
                                        {`${capitalizeEveryWord('Credit Notes')} `}
                                    </Typography>
                                </Grid>
                                <Grid xs={2} item>
                                    <Typography className="fw-bold" variant="h6">
                                        ({count(dashboardReducer.dashboardData[typeIndex].data.credit_notes)})
                                    </Typography>
                                </Grid>
                            </Grid>

                        )
                        }

                        {/* <Typography variant="h6">{`Contact Name: ${info.ContactName}`}</Typography> */}
                        <Grid rowSpacing={2} justifyContent="space-between" container>
                            {isDefined(dashboardReducer.dashboardData[typeIndex].data.addresses) && dashboardReducer.dashboardData[typeIndex].data.addresses != null && Object.keys(dashboardReducer.dashboardData[typeIndex].data.addresses).map((address, i) => (
                                <Fragment key={address}>
                                    <ListAddresses type={address} address={dashboardReducer.dashboardData[typeIndex].data.addresses[address]} />
                                </Fragment>
                            ))}
                        </Grid>

                        <ProductTable data={dashboardReducer.dashboardData[typeIndex].data} />


                        <Surcharges data={dashboardReducer.dashboardData[typeIndex].data} />

                        <Divider />

                        <Totals data={dashboardReducer.dashboardData[typeIndex].data} />



                    </Stack>
                </Paper>
            </Stack> : (
                <>
                    {/* <h4 className="p-4">{dashboardReducer[typeIndex].message}</h4> */}
                </>
            )
        )
    );
}


export default RecordContainer